import { useQuery } from "@tanstack/react-query";
import { getAvatar } from "../api";
import { useContentfulClient } from "../ContentfulClientProvider";

/**
 * @param sessionId - while this function will work with any string, it is recommended to use the sessionId for the customer
 * @returns url of the customer avatar
 * @description This hook fetches the customer avatar url from Contentful using the sessionId. It uses react-query to manage the data fetching and caching.
 * The avatar is cached indefinitely (staleTime: Infinity) to avoid unnecessary network requests.
 * The sessionId is used as the query key to ensure that the data is unique to each session.
 */
export const useCustomerAvatar = (sessionId: string): string | undefined => {
    const contentfulClient = useContentfulClient();
    const { data } = useQuery({
        queryKey: [`customer-profile-${sessionId}`],
        queryFn: async () => await getAvatar(contentfulClient, sessionId),
        staleTime: Infinity,
    });
    return data;
};
